import React from "react";
import { Link } from "react-router-dom";
import { ALL_DOCS, BUSINESS } from "@/pages/legal/_content";
import Logo from "@/components/Logo";

// Kept as a component (rather than deleted) so any existing imports keep working.
// All placeholders are filled now, so this is just a pass-through.
export const RenderText = ({ text }) => <>{text}</>;

const Footer = () => (
  <footer className="mt-20 border-t border-slate-200 bg-slate-50">
    <div className="max-w-6xl mx-auto px-6 py-10 grid gap-8 md:grid-cols-4 text-sm">
      <div>
        <div className="flex items-center gap-2 font-display font-bold text-slate-900">
          <Logo size={28} variant="dark"/>
          CarryIt
        </div>
        <p className="mt-3 text-slate-500 leading-relaxed text-xs">
          CarryIt is an intermediary and technology platform that connects
          senders with independent travellers. It is not a courier or
          logistics company.
        </p>
      </div>
      <div>
        <div className="text-xs uppercase tracking-wider text-slate-400 font-semibold mb-3">Legal & policies</div>
        <ul className="space-y-1.5">
          {ALL_DOCS.slice(0, 5).map((d) => (
            <li key={d.slug}><Link to={`/${d.slug}`} className="text-slate-600 hover:text-slate-900" data-testid={`footer-link-${d.slug}`}>{d.title}</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <div className="text-xs uppercase tracking-wider text-slate-400 font-semibold mb-3">More</div>
        <ul className="space-y-1.5">
          {ALL_DOCS.slice(5).map((d) => (
            <li key={d.slug}><Link to={`/${d.slug}`} className="text-slate-600 hover:text-slate-900" data-testid={`footer-link-${d.slug}`}>{d.title}</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <div className="text-xs uppercase tracking-wider text-slate-400 font-semibold mb-3">Registered office</div>
        <div className="text-slate-600 text-xs leading-relaxed">
          <div className="font-medium text-slate-900"><RenderText text={BUSINESS.legalName}/></div>
          <div className="text-[11px] text-slate-500">Operator of the CarryIt platform</div>
          <div className="mt-1"><RenderText text={BUSINESS.address}/></div>
          <div className="mt-2">Email: <a href={`mailto:${BUSINESS.email}`} className="hover:underline">{BUSINESS.email}</a></div>
          <div>Phone: <RenderText text={BUSINESS.phone}/></div>
          <div className="mt-2">CIN: <RenderText text={BUSINESS.cin}/></div>
          <div>GSTIN: <RenderText text={BUSINESS.gstin}/></div>
          <div className="mt-2">Website: <a href={`https://${BUSINESS.website}`} target="_blank" rel="noreferrer" className="hover:underline">{BUSINESS.website}</a></div>
        </div>
      </div>
    </div>
    <div className="border-t border-slate-200 py-4 text-center text-[11px] text-slate-400">
      © {new Date().getFullYear()} <RenderText text={BUSINESS.legalName}/>. All rights reserved.
    </div>
  </footer>
);

export default Footer;
